<template>
  <div class="SEBOMReportComponent DataTables">
    <p>{{ lang.infotext_1 }}:</p>

    <b-row>
      <b-col>
        <b-form-group
          id="label_report_list"
          :label="lang.labelSelect"
          label-for="report_list"
        >
          <b-form-select
            class="report_list"
            id="report_list"
            v-model="selectedReport"
            :options="reportList"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <!-- <canvas id="myGrid" ref="gridCanvas" class="text-right"></canvas> -->
      </b-col>
      <b-col>
        <!-- <canvas id="myLegend"></canvas> -->
      </b-col>
      <b-col>
        <ChartReportComponent :bomId="bomId" :selectedReport="categories[this.selectedReport][0]"></ChartReportComponent>
      </b-col>
    </b-row>

    <div :id="id">
      <LoaderComponent v-if="!isData"></LoaderComponent>
    </div>

    <br />
  </div>
</template>

<script>
var $ = require("jquery");
var jQuery = $;
window.$ = $;
window.jQuery = $;
var jquery = $;

import * as Tools from "@/Tools/Tools";
import dt from "datatables.net-bs4";

//import { drawChart, drawLegend } from "@/Tools/SquareChart.js";
//to delete
// import { GetMock } from "@/Tools/Mock.js";

require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import "datatables.net-select-bs4/css/select.bootstrap4.min.css";
import "datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css";

import { mapGetters } from "vuex";
import LoaderComponent from "@/components/shared/LoaderComponent";
import { forEach } from "jszip/lib/object";
import ChartReportComponent from "@/components/shared/ChartReportComponent";

export default {
  name: "BOMReportComponent",
  props: {
    lang: Object,
  },
  components: {
    LoaderComponent,
    ChartReportComponent,
  },
  data() {
    return {
      name: "SEBOMReportComponent",
      id: "tableplace_" + this._uid,
      reportList: [
        //{ value: null, text: 'Please select an report' },
        { value: 0, text: "OverallRisk" },
        { value: 1, text: "RohsRisk" },
        { value: 2, text: "LifecycleRisk" },
        { value: 3, text: "MultiSourcingRisk" },
      ],
      selectedReport: 0,
      columns: [],
      colsAssign: [],
      categories: [
        ["OverallRisk", "LifeCycleRiskGrade", "Crosses"],
        ["RohsRisk", "RoHSVersion", "ChinaRoHSStatus"],
        ["LifecycleRisk", "PartStatus", "EstimatedYearsToEOL"],
        ["MultiSourcingRisk", "Crosses"],
      ],

      dblclick: false,

      lengthMenu: 20,
      unoInstance: null,
      chartData: [],
      dataPieChart: [
        { category: "High", value: 17, color: 0 },
        { category: "Low", value: 50, categoryId: 0 },
        { category: "Medium", value: 17, categoryId: 0 },
        { category: "Unknown", value: 16, categoryId: 0 },
      ],
      exluded_data: [],
    };
  },
  computed: {
    ...mapGetters({
      globalSettings: "globalSettings",
    }),
    isData() {
      return false;
    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }
    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    bomId() {
      return this.$route.query.bomId;
    },
  },
  created() {
    console.log("created");
  },
  watch: {
    selectedReport: function () {

      this.chartData = [];
      this.exluded_data = [];
      this.buildColumns();
    },
    tabIndex: function () {
      if (this.mainTable != "") {
        this.mainTable.rows().deselect();
      }
    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {
        for (let el in newValue) {
          if (newValue[el].name == this.id) {
            if (newValue[el].status == true) {
              this.buildColumns();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true,
    },
  },

  mounted: function () {
    this.buildColumns();
  },
  methods: {
    changeNumberOfitems(data) {


      this.exluded_data = [];

      for (let it in data) {

        if (data[it].hidden == true) {
          this.exluded_data.push(data[it].obj.Type);
        }
      }

      this.buildColumns();
    },


    buildColumns() {
      this.columns = [
        {
          name: this.lang.table_header_PartReference,
          alignInColumn: "left",
          type: "text",
          property: "col___partReference",
        },
        {
          name: this.lang.table_header_ManufacturerPartNumber,
          alignInColumn: "left",
          type: "taxt",
          property: "col___manufacturerPartNumber",
          propertyId: "",
        },
        {
          name: this.lang.table_header_Manufacturer,
          alignInColumn: "left",
          type: "text",
          property: "col___manufacturer",
          propertyId: "",
        },
        {
          name: this.lang.table_header_Description,
          alignInColumn: "left",
          type: "text",
          property: "col___description",
          propertyId: "",
        },
        {
          name: this.lang.table_header_Datasheet,
          alignInColumn: "left",
          type: "text",
          property: "col___datasheet",
          propertyId: "",
        },
      ];

      this.colsAssign = [
        { data: "col___partReference" },
        { data: "col___manufacturerPartNumber" },
        { data: "col___manufacturer" },
        { data: "col___description" },
        { data: "col___datasheet" },
        // { "data": "col___index" },
        //{ "data": "col___bomPartId" },
      ];

      for (let i = 0, lei = this.categories[this.selectedReport].length; i < lei; i++) {
        let obj = {
          name: this.categories[this.selectedReport][i],
          alignInColumn: "left",
          propertyId: this.categories[this.selectedReport][i],
          type: "part",
          property: "col___" + this.categories[this.selectedReport][i],
        };
        this.columns.push(obj);

        let objAssign = {
          data: "col___" + this.categories[this.selectedReport][i],
        };

        this.colsAssign.push(objAssign);
      }

      this.buildTable();
    },

    buildTable() {


      var tableplace = document.getElementById("tableplace_" + this._uid);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
        tableplace.removeChild(tableplace.firstChild);
      }

      var place = document.createElement("table");
      place.setAttribute("id", "place" + this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place);

      var tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      var columnDefs = [];

      let _vue = this;

      var len = this.columns.length;

      let y = 0;

      for (let i = 0; i < len; i++) {
        let el = {
          targets: i,
          className: "_dt-body-" + _vue.columns[i].alignInColumn,
          render: function (data, type, row, meta) {
            //console.log(data, row, meta)
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            // if (data.value.display != undefined) {
            //   data.value.display = $.fn.dataTable.render.text().display(data.value.display);
            // }

            let toDisplay = "";

            if (meta.col == 0) {
              return data.value.display;
            }
            if (meta.col == 1) {
              return data.value.display;
            }
            if (meta.col == 2) {
              return data.value.display;
            }
            if (meta.col == 3) {
              return data.value.display;
            }

            if (meta.col == 4) {
              if (data.value.display != null) {
				if (data.value.display.length != 0) {
					let pos = data.value.display.indexOf("http");
					if (pos > -1) {
					  return "<a href='" + data.value.display + "' target='_blank'>Link</a>";
					} else {
					  return data.value.display;
					}
				  } else {
					return "";
				  }
			  }
				return "";

            }
            if (meta.col == 5) {
              let status = "blue";

              if (data.value.display.toLowerCase() == "low") {
                status = "success";
              }
              if (data.value.display.toLowerCase() == "medium") {
                status = "warning";
              }
              if (data.value.display.toLowerCase() == "high") {
                status = "danger";
              }

              return (
                "<b-badge class='badge badge-" +
                status +
                " '>" +
                data.value.display +
                " </b-badge>"
              );
            }
            if (meta.col == 6) {
              return data.value.display;
            }
            if (meta.col == 7) {
              return data.value.display;
            }

            //to another props

            return toDisplay;
          },
        };

        columnDefs.push(el);

        var th1 = document.createElement("th");

        tr1.appendChild(th1);

        var br = document.createElement("br");
        var tx = document.createTextNode(this.columns[i].name);
        if (this.columns[i].type == "part") {
          tx = document.createTextNode(this.columns[i].name);
        }
        th1.appendChild(br);
        th1.appendChild(tx);
        //var input = document.createElement("input");
        //input.setAttribute("type", "text");
        //input.setAttribute("placeholder", "Search");
        //input.setAttribute("class", "form-control form-control-sm search-input-header");
        //th1.appendChild(input);
      }

      let vue = this;

      var option = {};

      option.keys = false;
      //json.data= datatable;
      option.myColumnFormats = this.columns;
      option.colReorder = false;
      option.lengthMenu = [
        [20, -1],
        [20, "All"],
      ];
      option.order = [[0, "asc"]];
      option.select = true;
      //option.searchDelay = 350;
      option.columns = this.colsAssign;
      option.columnDefs = columnDefs;

      option.dom = "<fBlr<t>ip>";

      option.processing = true;
      option.serverSide = true;

      option.initComplete = function (settings, json) {
        // vue.mainTable.columns().eq(0).each(function(colIdx) {
        //   $('input', vue.mainTable.column(colIdx).header()).on('keyup change', function () {
        //     vue.mainTable
        //       .column(colIdx)
        //       .search(this.value)
        //       .draw();
        //   });
        //   $('input', vue.mainTable.column(colIdx).header()).on('click', function(e) {
        //       e.stopPropagation();
        //   });
        //});
      };
      option.fnDrawCallback = function (oSettings) {};
      option.buttons = [
        {
          extend: "copy",
          className: "btn-" + vue.variant,
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          className: "btn-" + vue.variant,
          messageTop: function () {
            let projectNumber = vue.$store.getters.projectDetails.projectNumber;
            let bomName = vue.$store.getters.bomDetails.name;
            return (
              vue.lang.export_label_top1 +
              ": " +
              projectNumber +
              " | " +
              vue.lang.export_label_top2 +
              ": " +
              bomName
            );
          },
          exportOptions: {
            columns: ":visible",
          },
          autoPrint: true,
          style: "fullWidth",

          customize: function (win) {
            $(win.document.body).css("font-size", "10pt");

            $(win.document.body)
              .find("table")
              .addClass("compact")
              .css("font-size", "inherit");
          },
        },
        {
          extend: "csv",
          filename:
            vue.lang.export_label_top1 +
            "-" +
            vue.$store.getters.projectDetails.projectNumber +
            "_" +
            vue.lang.export_label_top2 +
            "-" +
            vue.$store.getters.bomDetails.name,
          className: "btn-" + vue.variant,
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "excel",
          filename:
            vue.lang.export_label_top1 +
            "-" +
            vue.$store.getters.projectDetails.projectNumber +
            "_" +
            vue.lang.export_label_top2 +
            "-" +
            vue.$store.getters.bomDetails.name,
          exportOptions: {
            columns: ":visible",
          },
          className: "btn-" + vue.variant,
          customize: function (xlsx) {
            var sheet = xlsx.xl.worksheets["BOM.xml"];
          },
        },
        {
          extend: "pdfHtml5",
          filename:
            vue.lang.export_label_top1 +
            "-" +
            vue.$store.getters.projectDetails.projectNumber +
            "_" +
            vue.lang.export_label_top2 +
            "-" +
            vue.$store.getters.bomDetails.name,
          messageTop: function () {
            let projectNumber = vue.$store.getters.projectDetails.projectNumber;
            let bomName = vue.$store.getters.bomDetails.name;
            return (
              vue.lang.export_label_top1 +
              ": " +
              projectNumber +
              " | " +
              vue.lang.export_label_top2 +
              ": " +
              bomName
            );
          },
          className: "btn-" + vue.variant,
          exportOptions: {
            columns: ":visible",
          },
          orientation: "landscape",
          pageSize: "A4",
          download: "open",

          styles: {
            fullWidth: {
              fontSize: 3,
              bold: true,
              alignment: "right",
              margin: [0, 1900, 0, 80],
            },
            subheader: {
              fontSize: 4,
            },
            superMargin: {
              margin: [20, 0, 40, 0],
              fontSize: 5,
            },
          },
          customize: function (doc) {
            doc.pageMargins = [10, 10, 10, 10];

            doc.styles.title.fontSize = 9;
            doc.defaultStyle.fontSize = 7;
            doc.styles.tableHeader.fontSize = 9;
            doc.content[0].text = doc.content[0].text.trim();

            let numberOfHeaders = columnDefs.length;

            if (numberOfHeaders > 10 && numberOfHeaders < 15) {
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            } else if (numberOfHeaders >= 15 && numberOfHeaders < 18) {
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            } else if (numberOfHeaders >= 18) {
              doc.defaultStyle.fontSize = 3;
              doc.styles.tableHeader.fontSize = 5;
            }
          },
        },
        {
          text: "Json",
          exportOptions: {
            columns: ":visible",
          },
          className: "btn-" + vue.variant,
          action: function (e, dt, button, config) {
            var data = dt.buttons.exportData();

            $.fn.dataTable.fileSave(
              new Blob([JSON.stringify(data)]),
              vue.lang.export_label_top1 +
                "-" +
                vue.$store.getters.projectDetails.projectNumber +
                "_" +
                vue.lang.export_label_top2 +
                "-" +
                vue.$store.getters.bomDetails.name +
                ".json"
            );
          },
        },
        {
          text: "Reload",
          exportOptions: {
            columns: ":visible",
          },
          className: "btn-" + vue.variant,
          action: function (e, dt, button, config) {
            vue.mainTable.ajax.reload();
          },
        },

        {
          extend: "colvis",
          className: "btn-" + vue.variant,
        },
      ];

      option.ajax = {
        //url: /*this.server + */ "/api/v3/partmanagement/parts/GetPhysicalHandmadeParts",
        url: /*this.server + */"/api/v3/projectmanagement/projects/GetBomTableReport",

        crossDomain: true,
        type: "POST",
        dataType: "json",
        cors: true,
        contentType: "application/json",
        secure: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // console.log(xhr.status)
          // console.log(thrownError)
          if (xhr.responseJSON == undefined) {
            let error = JSON.parse(xhr.responseText);

            let obj = {
              text: vue.lang.alert_error_GetParts + " " + error.message,
              time: 15,
              type: "danger",
            };

            vue.$store.dispatch("displayFooterAlert", obj);
            return;
          }
          if (xhr.responseJSON.message == "Authorization failure.") {
            vue.$store.dispatch("logout");
          }
        },
        // dataSrc: function(json) {
        //   // wyklucz rekordy z kolumną 0 = 'bb' lub 'cc'
        //   console.log("tr",json.data.filter(row => !['Low', 'Unknown'].includes(row[5])))
        //   return json.data.filter(row => !['Low', 'Unknown'].includes(row[5]));
        // },
        data: function (json) {
          //json.exclude_values = vue.exluded_data.join(",");

          json.bomId = vue.bomId;
          json.reportType = vue.reportList[vue.selectedReport].text;
		      json.exclude_values = vue.exluded_data;//.join(",");


		      for (let i = 0, lei = json.columns.length; i < lei; i++) {
            json.columns[i].col = i;
            if (i == 5) {
              json.columns[i].exclude_values = vue.exluded_data.join(",");
            } else {
              json.columns[i].exclude_values = [];
            }

          }

          //console.log(json);
          //console.log(JSON.stringify(json, null, 2));

          return JSON.stringify(json);
          //}
        },
        dataFilter: function (data) {
          //todo
          //vue.$store.dispatch("deleteAllSelectedRows");
          //console.log(data)

          y = 0;
          var json = JSON.parse(data);
          //console.log(json)
          if (json.data == null) {
            return;
          }

          //to delete
          // let getSEBomReport = new GetMock();
          // json = getSEBomReport.getBomTableReport();

          // console.log(json);
          //to delete

          let newJson = {
            draw: json.data.draw,
            recordsFiltered: json.data.recordsFiltered,
            recordsTotal: json.data.recordsTotal,
            data: [],
          };
          let rows = [];
          vue.lengthMenu = json.data.data.length;

          for (let i = 0, lei = json.data.data.length; i < lei; i++) {
            if (json.data.data[i].reportDetails != null) {
              let row = {};

              // let objIndex = {
              //   bomPartId: json.data.data[i].index,
              //   value: {
              //     display: json.data.data[i].index,
              //     filter: json.data.data[i].index,
              //     sort: json.data.data[i].index,
              //   },
              // };
              // let index = "col___index";
              // row[index] = objIndex;

              let objpartReference = {
                bomPartId: json.data.data[i].parts[0].bomPartId,
                revisionId: json.data.data[i].parts[0].revisionId,
                revision: json.data.data[i].parts[0].revision,
                partId: json.data.data[i].parts[0].partId,
                partNumber: json.data.data[i].parts[0].partNumber,
                partReference: json.data.data[i].parts[0].partReference,
                value: {
                  display: json.data.data[i].parts[0].partReference,
                  filter: json.data.data[i].parts[0].partReference,
                  sort: json.data.data[i].parts[0].partReference,
                },
              };
              let index = "col___partReference";
              row[index] = objpartReference;

              let objManufacturer = {
                manufacturer:
                  json.data.data[i].reportDetails.Manufacturer,
                value: {
                  display: json.data.data[i].reportDetails.Manufacturer,
                  filter: json.data.data[i].reportDetails.Manufacturer,
                  sort: json.data.data[i].reportDetails.Manufacturer,
                },
              };
              let manufacturer = "col___manufacturer";
              row[manufacturer] = objManufacturer;

              let objManufacturerPartNumber = {
                manufacturerPartNumber:
                  json.data.data[i].reportDetails.ManufacturerPartNumber,
                value: {
                  display: json.data.data[i].reportDetails.ManufacturerPartNumber,
                  filter: json.data.data[i].reportDetails.ManufacturerPartNumber,
                  sort: json.data.data[i].reportDetails.ManufacturerPartNumber,
                },
              };
              let manufacturerPartNumber = "col___manufacturerPartNumber";
              row[manufacturerPartNumber] = objManufacturerPartNumber;

              let objDescription = {
                description: json.data.data[i].reportDetails.Description,
                value: {
                  display: json.data.data[i].reportDetails.Description,
                  filter: json.data.data[i].reportDetails.Description,
                  sort: json.data.data[i].reportDetails.Description,
                },
              };
              let description = "col___description";
              row[description] = objDescription;

              let objDatasheet = {
                datasheet: json.data.data[i].reportDetails.Datasheet,
                value: {
                  display: json.data.data[i].reportDetails.Datasheet,
                  filter: json.data.data[i].reportDetails.Datasheet,
                  sort: json.data.data[i].reportDetails.Datasheet,
                },
              };
              let datasheet = "col___datasheet";
              row[datasheet] = objDatasheet;

              for (let j = 0, lej = _vue.categories[_vue.selectedReport].length; j < lej; j++) {
                if (_vue.categories[_vue.selectedReport][j] == "OverallRisk") {
                  let OverallRisk = "";
                  let valOverallRisk = "Unknown";
                  let statusOverallRisk = "primary";
                  let string = false;
                  if (json.data.data[i].reportDetails.OverallRisk != undefined) {
                    if (json.data.data[i].reportDetails.OverallRisk == "Low" || json.data.data[i].reportDetails.OverallRisk == "Medium" || json.data.data[i].reportDetails.OverallRisk == "High" || json.data.data[i].reportDetails.OverallRisk == "Unknown") {
                      OverallRisk = json.data.data[i].reportDetails.OverallRisk;
                      string = true;
                      valOverallRisk = json.data.data[i].reportDetails.OverallRisk;
                      if (valOverallRisk == "Low") {
                        statusOverallRisk = "success";
                      }
                      if (valOverallRisk == "Medium") {
                        statusOverallRisk = "warning";
                      }
                      if (valOverallRisk == "High") {
                        statusOverallRisk = "danger";
                      }

                    } else {
                      OverallRisk = json.data.data[i].reportDetails.OverallRisk.split("%");
                      string = false;
                    }

                  }
                  if (string == false) {
                    if (OverallRisk != "") {
                      if (OverallRisk[0] <= _vue.globalSettings.SERiskRange1) {
                        valOverallRisk = "Low";
                        statusOverallRisk = "success";
                        if (OverallRisk == "") {
                          valOverallRisk = "Unknown";
                          statusOverallRisk = "info";
                        }
                      } else if (OverallRisk[0] > _vue.globalSettings.SERiskRange2) {
                        valOverallRisk = "High";
                        statusOverallRisk = "danger";
                      } else if (
                        OverallRisk[0] > _vue.globalSettings.SERiskRange1 &&
                        OverallRisk[0] <= _vue.globalSettings.SERiskRange2
                      ) {
                        valOverallRisk = "Medium";
                        statusOverallRisk = "warning";
                      }
                    } else {
                    }

                  }


                  //_vue.addToChartData(valOverallRisk);

                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: valOverallRisk,
                      filter: valOverallRisk,
                      sort: valOverallRisk,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;
                }
                if (_vue.categories[_vue.selectedReport][j] == "LifeCycleRiskGrade") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.LifeCycleRiskGrade,
                      filter: json.data.data[i].reportDetails.LifeCycleRiskGrade,
                      sort: json.data.data[i].reportDetails.LifeCycleRiskGrade,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;
                }
                if (_vue.categories[_vue.selectedReport][j] == "Crosses") {
                  let len = json.data.data[i].reportDetails.Crosses;
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],
                    name: _vue.categories[_vue.selectedReport][j],
                    value: {
                      display: len,
                      filter: len,
                      sort: len,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;
                }

                if (_vue.categories[_vue.selectedReport][j] == "RohsRisk") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.RohsRisk,
                      filter: json.data.data[i].reportDetails.RohsRisk,
                      sort: json.data.data[i].reportDetails.RohsRisk,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;

                  //_vue.addToChartData(json.data.data[i].reportDetails.RohsRisk);
                }
                if (_vue.categories[_vue.selectedReport][j] == "RoHSVersion") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.RoHSVersion,
                      filter: json.data.data[i].reportDetails.RoHSVersion,
                      sort: json.data.data[i].reportDetails.RoHSVersion,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;
                }
                if (_vue.categories[_vue.selectedReport][j] == "ChinaRoHSStatus") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.ChinaRoHSStatus,
                      filter: json.data.data[i].reportDetails.ChinaRoHSStatus,
                      sort: json.data.data[i].reportDetails.ChinaRoHSStatus,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;
                }
                if (_vue.categories[_vue.selectedReport][j] == "LifecycleRisk") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.LifecycleRisk,
                      filter: json.data.data[i].reportDetails.LifecycleRisk,
                      sort: json.data.data[i].reportDetails.LifecycleRisk,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;

                  //_vue.addToChartData(json.data.data[i].reportDetails.LifecycleRisk);
                }
                if (_vue.categories[_vue.selectedReport][j] == "PartStatus") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.PartStatus,
                      filter: json.data.data[i].reportDetails.PartStatus,
                      sort: json.data.data[i].reportDetails.PartStatus,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;
                }
                if (_vue.categories[_vue.selectedReport][j] == "EstimatedYearsToEOL") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.EstimatedYearsToEOL,
                      filter: json.data.data[i].reportDetails.EstimatedYearsToEOL,
                      sort: json.data.data[i].reportDetails.EstimatedYearsToEOL,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;
                }

                if (_vue.categories[_vue.selectedReport][j] == "MultiSourcingRisk") {
                  let obj = {
                    propertyId: _vue.categories[_vue.selectedReport][j],

                    value: {
                      display: json.data.data[i].reportDetails.MultiSourcingRisk,
                      filter: json.data.data[i].reportDetails.MultiSourcingRisk,
                      sort: json.data.data[i].reportDetails.MultiSourcingRisk,
                    },
                  };

                  let key = "col___" + _vue.categories[_vue.selectedReport][j];
                  row[key] = obj;

                  //_vue.addToChartData(json.data.data[i].reportDetails.MultiSourcingRisk);
                }
              }
              rows.push(row);
            }
          }
          //_vue.startDrawChart();

          newJson.data = rows;

          //console.log(newJson)

          return JSON.stringify(newJson);
        },
      };

      if ($.fn.dataTable.isDataTable("#place" + this._uid)) {
        this.mainTable.destroy();
      }

      this.mainTable = $("#place" + this._uid).DataTable(option);

      //this.mainTable.column(0).visible(false);

      let _mainTable = this.mainTable;

      let el = document.getElementsByClassName("dataTables_processing")[0];

      if (el !== null) {
        el.classList.add("processing-top");
      }

      //search input change view
      let searchplace = document.getElementById("place" + this._uid + "_filter")
        .firstChild;

      while (searchplace.firstChild) {
        if (searchplace.firstChild.textContent == "Search:") {
          searchplace.removeChild(searchplace.firstChild);
          break;
        }
      }

      searchplace.firstChild.setAttribute("placeholder", "Enter search words");
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
      searchplace.firstChild.addEventListener("input", function (evt) {
        _vue.$store.dispatch("setFilteredData", evt.target.value);
      });
      let lengthplace = document.getElementById("place" + this._uid + "_length");

      if (lengthplace.firstChild.firstChild != null) {
        lengthplace.firstChild.firstChild.nextSibling.setAttribute(
          "class",
          "form-control form-control-sm select-length"
        );
      }

      var stepWait = 0;
      var waitInterval;
      $(".dataTables_filter input")
        .unbind()
        .bind("input", function (e) {
          var item = $(this);
          stepWait = 0;

          if (!waitInterval) {
            waitInterval = setInterval(function () {
              if (stepWait >= 3) {
                clearInterval(waitInterval);
                waitInterval = "";
                let searchString = $(item).val();
                _mainTable.search(searchString).draw();
                stepWait = 0;
              }
              stepWait++;
            }, 150);
          }
        });

      this.mainTable
        .on("select", function (e, dt, type, indexes) {
          let rowData = _mainTable.rows(".selected").data();



          const obj = {
            "remarks": rowData[0].col___partReference.remarks,
            "partNumber": rowData[0].col___partReference.partNumber,
            "PartReference": rowData[0].col___partReference.partReference,
            "revision":  rowData[0].col___partReference.revision,
            "assembly": null,
            "bomPartId": null,
            "isManual": null,
            "isPresent": null,
            "partId":  rowData[0].col___partReference.partId,
            "revisionId":  rowData[0].col___partReference.revisionId,
            "status": null,
            "quantity": null
          }

          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", obj)

        })
        .on("deselect", function (e, dt, type, indexes) {
          _vue.$store.dispatch("unselectAlternative");
          _vue.$store.dispatch(
            _vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow"
          );
        });

      // $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e) {
      //   let rowData = _mainTable.rows( this._DT_RowIndex ).data();

      //   _vue.goTo(rowData[0]);

      // } );
    },
  },
};
</script>

<style lang="scss">
.SEBOMReportComponent {
  table {
    font-size: 0.75rem;
    padding: 0px !important;
  }
  table th {
    padding: 2px !important;
  }
  table th select {
    width: 100% !important;
  }
  table td {
    padding: 0rem !important;

    padding-left: 0.2rem !important;
    padding-right: 0.2rem !important;
    //white-space:nowrap;
  }
  table.dataTable thead th {
    position: relative;
    background-image: none !important;
  }

  .dataTables_processing {
    position: absolute;
    top: 140px;
    left: 50%;
    width: 100%;
    height: 20px;
    margin-left: -50%;
    margin-top: 50px;
    padding-top: 5px;
    text-align: center;
    font-size: 1em;
  }
  .processing-top {
    top: 10px;
  }

  .dataTables_filter {
    font-size: 10px;
    float: left;
    width: 210px;
  }
  .dataTables_length {
    margin-left: 20px;
    width: 200px;
    float: left;
  }
  .dataTables_length label {
    display: inline-flex;
  }
  .select-length {
    padding: 0.1rem;
    margin-left: 10px;
    margin-right: 10px;
  }
  .searcher {
    float: left;
  }
  .dt-buttons {
    font-size: 0.7rem;
    //margin-left: 210px;
  }
  .dataTables_filter .form-control-sm,
  .input-group-sm > .form-control {
    padding: 0.1rem 0.1rem;
    font-size: 0.7rem;
    line-height: 1;
    width: 200px;
  }
  .btn {
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 3px;
    padding-right: 3px;

    font-size: 0.7rem;
  }
  .btn-group {
    display: block;
    padding-top: 2px;
    width: 450px;
    float: left;
  }
  ._dt-body-left {
    text-align: left;
  }
  ._dt-body-right {
    text-align: right;
  }
  ._dt-body-center {
    text-align: center;
  }
  .image-category {
    max-width: 40px;
    //border: solid 3px #666;
    border-radius: 2px;
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .search-input-header {
    margin-top: 5px;
  }
  .advanced-search-panel {
    display: block;
    margin-bottom: 15px;
    border: solid 1px #999;
    padding: 10px;
    border-radius: 5px;
  }
  .advanced-search tr {
    height: 28px;
  }

  .nodisplay {
    display: none;
  }
  .column-filter-input {
    width: 200px;
  }
  .badge {
    margin-right: 1px;

    margin-bottom: 2px;
  }
  .badges {
    margin-top: 3px;
    margin-bottom: 2px;
  }
  .report_list {
    max-width: 500px;
    height: 26px;
    padding-top: 2px;
  }
  // #myGrid {
  //   border: 2px solid #333;
  //   display: block;
  //   margin: 20px 0;
  //   float: right;
  // }
  // #myLegend {
  //   display: block;
  //   margin: 20px 0;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BOMReportComponent.vue